import { tWarning } from "../../i18n/engine";
import { t } from "../../i18n";
import type { EngineWarning } from "@tasduvar/engine";
export function WarningsList({ warnings }: { warnings: EngineWarning[] }): JSX.Element | null {
  if (warnings.length === 0) return null;
  const icon = { info: "ⓘ", warn: "!", error: "✗" } as const;
  return (
    <div>
      <h3 className="text-xs font-medium text-ink border-b border-rule pb-1 mb-1">{t("Uyarılar ve kabuller")}</h3>
      <ul className="text-[11px] grid gap-1">{warnings.map((w) => <li key={w.code + (w.context ?? "")} className={w.severity === "error" ? "text-bad" : w.severity === "warn" ? "text-amber-700" : "text-ink/75"}><span aria-hidden className="mr-1">{icon[w.severity]}</span>{tWarning(w.code, w.message)}{w.context ? ` (${w.context})` : ""}</li>)}</ul>
    </div>
  );
}
